import React, { useState } from "react";
import { connect } from "react-redux";

import { formTypes } from "../../constants";
import BaseModal from "../../shared/components/modals/BaseModal";

import LoginForm from "../auth-forms/LoginForm";
import ForgotForm from "../auth-forms/ForgotForm";
import SignupForm from "../agent-signup/SignupForm";
import RegisterForm from "../auth-forms/register-survey/RegisterForm";

const { TYPE_LOGIN, TYPE_FORGOT, TYPE_REGISTER, TYPE_AGENT_SIGNUP } = formTypes;

const Login = ({ isAuthenticated }) => {
  const [formType, setFormType] = useState(TYPE_LOGIN);
  const [openModal, setOpenModal] = useState(!isAuthenticated);

  const closeModal = () => {
    if (formType === TYPE_LOGIN) {
      setOpenModal(false);
    }
    changeFormType(TYPE_LOGIN);
  };

  const changeFormType = (type) => {
    setFormType(type);
  };

  return (
    <>
      {formType === TYPE_AGENT_SIGNUP && (
        <SignupForm
          show={openModal}
          onClose={closeModal}
          closeModal={closeModal}
          changeFormType={changeFormType}
        />
      )}
      {formType !== TYPE_AGENT_SIGNUP && (
        <BaseModal
          show={openModal}
          onClose={closeModal}
          showClose={formType !== TYPE_LOGIN}
          size={
            formType === TYPE_LOGIN || formType === TYPE_REGISTER ? "xl" : "xs"
          }
          changeFormType={changeFormType}
          backDropClass={`${formType === TYPE_LOGIN ? "login-modal" : ""} ${
            formType === TYPE_FORGOT ? "login-modal-backdrop" : ""
          }`}
          dialogClassName={`${formType === TYPE_LOGIN ? "login-dialog" : ""} ${
            formType === TYPE_LOGIN || formType === TYPE_FORGOT
              ? "login-modal-dialog"
              : ""
          }`}
        >
          {formType === TYPE_LOGIN && (
            <LoginForm
              changeFormType={changeFormType}
              closeModal={closeModal}
            />
          )}
          {formType === TYPE_FORGOT && (
            <ForgotForm changeFormType={changeFormType} />
          )}
          {formType === TYPE_REGISTER && (
            <RegisterForm
              closeModal={closeModal}
              changeFormType={changeFormType}
            />
          )}
        </BaseModal>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.authReducer.isAuthenticated,
});

export default connect(mapStateToProps, null)(Login);
